import React, { useCallback, useEffect, useRef } from 'react';
import { searchResultsPropTypes } from './SearchResultsPropTypes';
import Container from '@Theme/natucare/components/Container/Container';
import SearchResultsProducts from './components/SearchResultsProducts/SearchResultsProducts';
import SearchResultsContent from './components/SearchResultsContent/SearchResultsContent';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './SearchResults.module.scss';
const constructFormData = (searchPhrase, searchTarget = null) => {
  const data = {
    search_phrase: searchPhrase,
    search_target: searchTarget,
    site_id: 2,
    request_uri: window.location.href
  };
  const formData = new FormData();
  Object.keys(data).forEach(key => formData.set(key, data[key]));
  return formData;
};
const SearchResults = ({
  searchResults,
  setIsSearching,
  isSearching,
  searchTerm,
  sendSearchData
}) => {
  const rootRef = useRef();
  const isFirstRender = useRef(true);
  const handleClick = useCallback(e => {
    const clickedAnchor = e.target.closest('a');
    if (clickedAnchor) {
      const clickedAnchorHref = clickedAnchor.getAttribute('href');
      const formData = constructFormData(searchTerm, clickedAnchorHref);
      sendSearchData(formData);
    }
  }, [searchTerm]);
  useEffect(() => {
    if (rootRef.current) {
      rootRef.current.scrollTop = 0;
    }
    if (!isFirstRender.current) {
      if (typeof window !== 'undefined' && isSearching === false) {
        const formData = constructFormData(searchTerm);
        sendSearchData(formData);
      }
    } else {
      isFirstRender.current = false;
    }
  }, [isSearching]);
  useEffect(() => {
    const rootElement = rootRef.current;
    if (rootElement) {
      rootElement.addEventListener('click', handleClick);
    }
    return () => {
      if (rootElement) {
        rootElement.removeEventListener('click', handleClick);
      }
    };
  }, [handleClick]);
  const status = searchResults.status;
  const isFetching = !status.isLoaded && status.isFetching && !searchResults.stringNotFound;
  const isFetchedWithoutResults = status.isLoaded && !status.isFetching && searchResults.stringNotFound;
  const isFetchedWithResults = status.isLoaded && !status.isFetching && !searchResults.stringNotFound;
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${isSearching ? styles.rootSearching : ''}`,
    ref: rootRef
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, isFetching && /*#__PURE__*/React.createElement(Icon, {
    name: "loaderDotsAnimation",
    size: {
      width: 100,
      height: 100
    },
    classname: styles.rootIconLoading
  }), isFetchedWithoutResults && /*#__PURE__*/React.createElement("div", {
    className: styles.rootNotFound
  }, `${searchResults.notFoundDescription} “${searchResults.stringNotFound}”.`), isFetchedWithResults && /*#__PURE__*/React.createElement(React.Fragment, null, searchResults.products && /*#__PURE__*/React.createElement(SearchResultsProducts, searchResults.products), searchResults.content && /*#__PURE__*/React.createElement(SearchResultsContent, {
    items: searchResults.content
  })), isSearching && /*#__PURE__*/React.createElement(Icon, {
    name: "searchResultsClose",
    size: {
      width: 32,
      height: 32
    },
    onClick: () => setIsSearching(false),
    classname: styles.rootIcon
  })));
};
export default SearchResults;